import { mapValues } from 'es-toolkit';
import { createContext, type ReactNode, useContext, useRef } from 'react';
import type { ReactStores, Stores } from 'src/common/stores';

export const StoresContext = createContext<ReactStores | null>(null);

interface StoresProviderProps {
  children: ReactNode;
  stores: Stores;
}

export function StoresProvider({ children, stores }: StoresProviderProps) {
  const storesRef = useRef<ReactStores | null>(null);

  if (storesRef.current === null) {
    storesRef.current = mapValues(stores.instance, (store) => store?.use) as ReactStores;
  }

  return <StoresContext.Provider value={storesRef.current}>{children}</StoresContext.Provider>;
}

export function useStores() {
  const stores = useContext(StoresContext);

  if (!stores) {
    throw new Error('useStores must be used within a StoresProvider');
  }

  return stores;
}
